import { Colors, Services } from '@sigma-frontend-libs/commons'
import { PAYMENTS_METHODS } from '@sigma-legacy-libs/essentials/lib/constants'

import { buttonModes, components, icons } from '@/utils'

import button from '@/components/button'
import squircle from '@/components/icon/squircle'
import arrow from '@/components/misc/arrow'

function renderHeaderContent(h, options) {
  const { serviceName, path } = options

  return h(
    'div',
    {
      class: 'faic grid-gap--8'
    },
    [
      h(
        squircle,
        {
          props: {
            iconSVG: 'RUB',
            color: Colors.grey
          }
        }
      ),
      this.getTranslate(`${serviceName}.subtitles.${path}`)
    ]
  )
}
function renderHeader(h, options, expanded) {
  return h(
    'div',
    {
      class: 'default-expansion-panel-header pl-2'
    },
    [
      renderHeaderContent.call(this, h, options),
      h(arrow, { props: { expanded } })
    ]
  )
}

function renderItemHeaderContent(h, method) {
  return h(
    'div',
    {
      class: 'faic grid-gap--8'
    },
    [
      h(
        squircle,
        {
          props: {
            iconSVG: method,
            color: method
          }
        }
      ),
      this.getTranslate(`${Services.payments}.methods.${method}`)
    ]
  )
}
function renderItemHeader(h, method, expanded) {
  return h(
    'div',
    {
      class: 'default-expansion-panel-header pl-2'
    },
    [
      renderItemHeaderContent.call(this, h, method),
      h(arrow, { props: { expanded } })
    ]
  )
}
function renderPaymentMethodProp(h, { method, prop }) {
  switch (typeof this.proxy[method][prop]) {
    case 'boolean': {
      return h(
        components.switch,
        {
          props: {
            value: this.proxy[method][prop],
            label: this.getTranslate(`payments.labels.methods.${method}.${prop}`),
            outline: true
          },
          on: {
            input: event => {
              this.proxy[method][prop] = event
            }
          }
        }
      )
    }

    case 'string':
    default: {
      const visibilityProps = {}
      switch (prop) {
        case 'Password':
        case 'ekamToken':
        case 'apikey':
        case 'secret': {
          let fieldAfterIcon
          let fieldType
          if (this.visibility[method][prop]) {
            fieldAfterIcon = 'visibility'
          } else {
            fieldAfterIcon = 'visibility_off'
            fieldType = 'password'
          }
          visibilityProps.afterIcon = fieldAfterIcon
          visibilityProps.afterIconCallback = () => {
            this.visibility[method][prop] = !this.visibility[method][prop]
          }
          visibilityProps.type = fieldType
          break
        }
      }

      return h(
        components['text-field'],
        {
          props: {
            value: this.proxy[method][prop],
            label: this.getTranslate(`payments.labels.methods.${method}.${prop}`),
            name: `${method}.${prop}`,
            autocomplete: 'off',
            defaultValue: '',
            dense: true,
            clearable: true,
            details: false,
            ...visibilityProps
          },
          on: {
            input: event => {
              this.proxy[method][prop] = event
            }
          }
        }
      )
    }
  }
}
function renderItemBody(h, options, method) {
  const props = Object.keys(options.defaults[options.path][method])

  return h(
    'div',
    {
      class: 'grid grid-gap--12 pa-2'
    },
    [
      props.map(prop => {
        return renderPaymentMethodProp.call(this, h, {
          method,
          prop
        })
      })
    ]
  )
}
function renderItem(h, options, method) {
  return h(
    components['expansion-panel'],
    {
      props: {
        outline: true,
        rounded: true
      },
      scopedSlots: {
        header: ({ expanded }) => {
          return renderItemHeader.call(this, h, method, expanded)
        },
        default: () => {
          return renderItemBody.call(this, h, options, method)
        }
      }
    }
  )
}
function renderItems(h, options) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8 pt-2 px-2'
    },
    [
      PAYMENTS_METHODS.map(method => {
        return renderItem.call(this, h, options, method)
      })
    ]
  )
}
function renderBody(h, options) {
  return h(
    'div',
    {
      class: 'grid grid-gap--0'
    },
    [ renderItems.call(this, h, options) ]
  )
}

function renderFooter(h) {
  return h(
    'div',
    {
      class: 'dialog__footer'
    },
    [
      h(
        button,
        {
          props: {
            icon: icons.save,
            color: Colors.primary,
            mode: buttonModes.flat,
            label: this.getTranslate('misc.buttons.save'),
            loading: this.loading,
            disabled: this.disabled
          },
          on: {
            click: () => {
              this.submit()
            }
          }
        }
      )
    ]
  )
}
function renderContent(h, options) {
  return h(
    'div',
    {
      class: 'grid grid-gap--0'
    },
    [
      renderBody.call(this, h, options),
      renderFooter.call(this, h)
    ]
  )
}

export default function(h, options) {
  return h(
    components['expansion-panel'],
    {
      props: {
        outline: true,
        rounded: true
      },
      scopedSlots: {
        header: ({ expanded }) => {
          return renderHeader.call(this, h, options, expanded)
        },
        default: () => {
          return renderContent.call(this, h, options)
        }
      }
    }
  )
}
